import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { sizes } from 'src/styles/Media.styled';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import { StyledBox } from './Discrepancy.styled';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles(() => ({
    paper: {
        padding: '13px 17px 13px 15px',
    },
}));


const HeaderTemplate = () => {
    const classes = useStyles();
    const winWidth = window.innerWidth;
    const isMobileView = winWidth <= sizes.mobileDevice;
    const isDesktopView = winWidth >= sizes.mediumDevice;
    const {t} =  useTranslation();
    return (
        <React.Fragment>
            <StyledBox
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                style={{
                    height: '48px',
                    borderRadius: '6px 6px 0px 0px',
                    background: '#FFFFFF 0% 0% no-repeat padding-box',
                    boxShadow: '0px 3px 2px #00000029',
                    border: '1px solid #DCDCDC',
                }}
            >
                <Grid
                    container
                    alignItems={'flex-start'}
                    justifyContent={'space-between'}
                >
                    <Grid item xs={4} lg={4} sm={4}>
                        <StyledTextDiv opacity={0.7}>
                            {t('reportUsage.review.discrepancy.RowHeaderDesktop.itemDescription')}
                        </StyledTextDiv>
                    </Grid>
                    <Grid item xs={1} lg={1} sm={1}>
                        <StyledTextDiv opacity={0.7}>{t('reportUsage.itemList.uom')}</StyledTextDiv>
                    </Grid>

                    <Grid item xs={1} lg={1} sm={1}>
                        <StyledTextDiv
                            opacity={0.7}
                            textAlign={
                                !isDesktopView && !isMobileView && 'start'
                            }
                        >
                            {t('orders.orderListFilterDropDown.usage.categoryName')}
                        </StyledTextDiv>
                    </Grid>
                    <Grid item xs={3} lg={3} sm={3}>
                        <StyledTextDiv opacity={0.7} textAlign={'center'}>
                                {t(
                                    'reportUsage.review.discrepancy.RowHeaderDesktop.qtyReportedByMedRep'
                                )}
                        </StyledTextDiv>
                    </Grid>
                    <Grid item xs={3} lg={3} sm={3}>
                        <StyledTextDiv opacity={0.7} textAlign={'center'}>
                        {t(
                                    'reportUsage.review.discrepancy.RowHeaderDesktop.qtyReportedByHos'
                                )}
                        </StyledTextDiv>
                    </Grid>
                </Grid>
            </StyledBox>
        </React.Fragment>
    );
};

export default HeaderTemplate;
